<template>
  <div>
    <el-dropdown trigger="click">
      <span class="el-dropdown-link p-2">
        <router-link to="/wishlist">
          <img class="mx-auto" src="../../../assets/images/icon-heart.png" />
          <span class="hover:text-teal-400 display-450">Merkliste</span>
        </router-link>
      </span>
      <el-dropdown-menu slot="dropdown"></el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {};
</script>

<style>

@media(max-width:450px){
  .display-450{
    display: none;
  }
}

</style>
